
const digest = '19bccfd680616d838505e4dfc6de8cbae7642286bbb884c8e9e044e83252fed2';
const classes = {"wrapper":"_wrapper_tjq0b_1","title":"_title_tjq0b_10","isOpen":"_isOpen_tjq0b_33","text":"_text_tjq0b_36"};
const css = `._wrapper_tjq0b_1 {
  display: flex;
  flex-direction: column;
  background: #f3f4f5;
  border-radius: 25px;
  padding: 20px;
  gap: 10px;
  cursor: pointer;
}
._wrapper_tjq0b_1 ._title_tjq0b_10 {
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  position: relative;
  color: #191c1d;
  padding-right: 40px;
}
._wrapper_tjq0b_1 ._title_tjq0b_10::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 15px;
  height: 20px;
  text-align: center;
  line-height: 32px;
  padding-left: 1px;
  background-image: url("/dist/icons/chevron-blue-down.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
._wrapper_tjq0b_1 ._title_tjq0b_10._isOpen_tjq0b_33::after {
  background-image: url("/dist/icons/chevron-blue-up.svg");
}
._wrapper_tjq0b_1 ._text_tjq0b_36 {
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  